/*
 * Created by alex@hackerbay.com on 3.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate, Trans} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Button, Col, Container, Row} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import Subtitle from "../../components/Subtitle";
import InfoBox from "../../components/InfoBox";
import FullWidthSaveToCalendarButton from "../../components/FullWidthSaveToCalendarButton";
import StatusBox from "../../components/StatusBox";
import StatusBar from "../../components/StatusBar";
import RouterShipmentTrackingBox from "../../components/RouterShipmentTrackingBox";
import StackedBottomButtonPair from "../../components/StackedBottomButtonPair";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import {StatusBarDesktop} from "../../components/StatusBarDesktop";
import moment from "moment";
import timeSlotFormatter from "../../timeSlotFormatter";
import technicianAppointmentRequired from "../../technicianRequired";
import {hardwareWasShipped} from "../../hardwareHelper";
import {STAGES} from "../Stage";
import {getDaysUntilAppointment} from "../../checkCareStageHelper";
import vodafoneLogo from "../../media/icons/vf-logo.png";

class Stage8AppointmentDayPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
        }
    }

    getInfoBox = (noteTextResource, noteTimeProp) => {
        if(this.props.callbackRequestedSuccessfully){
            return <InfoBox
                cardType={"info"}
                textResource={"callback_note"}
                showCalendarLink={false}
                imgUrl={"/favicon.ico"}
            />;
        }
        return  <InfoBox
            cardType={"info"}
            textResource={noteTextResource}
            time={noteTimeProp}

        />;
    };

    /**
     * #267 get YouTube Embedded MyTechie-Video
     * @returns {*}
     */
    getYouTubeMyTechie = () => {

        // #267 MyTechie Hinweis
        const youtubeEmbedSrc = `https://www.youtube.com/embed/9w-5MePiSMw`;

        // mobile
        if(isMobile){
            return <div className={"mytechie"}>
                <Row>
                    <Col xs={12}>
                        <div style={{width:"100%", height:"200px"}}>
                            <iframe
                                width="100%"
                                height="100%"
                                src={youtubeEmbedSrc}
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen={true}
                            />
                        </div>
                    </Col>
                </Row>
                <SpacerRow/>
            </div>;

        // desktop
        } else {
            return <div className={"mytechie"}>
                <Row>
                    <Col xs={12}>
                        <div style={{width:"100%", height:"200px"}}>
                            <iframe
                                width="100%"
                                height="100%"
                                src={youtubeEmbedSrc}
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen={true}
                            />
                        </div>
                    </Col>
                </Row>
                <SpacerRow/>
            </div>;
        }

    };

    render() {
        let headerTextResource;
        let bodyTextResource;
        let noteTextResource;
        let youtubeResource;
        let upperButtonTextResource;
        let infoBox;

        upperButtonTextResource = "set_up_router";

        const nowHour = moment().get("hours");
        const timeSlot = this.props.ds360APIResult.appointmentTimeSlot;
        const timeSlotFormatted = timeSlotFormatter(timeSlot);
        const timeSlotEnd = timeSlotFormatted.endHour;
        let noteTimeProp = timeSlotFormatted.text;

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        // #266 check if current moment = appointment day or if appointment day is in the past
        const proposalMoment = moment(this.props.ds360APIResult.proposalDate);
        const momentDiff = getDaysUntilAppointment(proposalMoment);
        // console.log( "momentDiff: " + momentDiff );

        // appointment day is in the past
        if( momentDiff < 0 ) {

            headerTextResource = "appointment_passed_title";
            bodyTextResource = "is_it_done_body";
            noteTextResource = "technician_late";
            noteTimeProp = timeSlotEnd+1;

            // #267#note-9 - do not show infobox after apointment day
            // infoBox = this.getInfoBox(noteTextResource, noteTimeProp);

        // appointment day is today
        } else {

            // show different content depending on current time compared with time slot end-time of appointment
            // console.log( "nowHour: " + nowHour + " - timeSlotEnd: " + timeSlotEnd );

            // we are still in technician time frame
            if(nowHour < timeSlotEnd){
                headerTextResource = "has_everything_worked_out_title";
                bodyTextResource = "has_everything_worked_out_body_mytechie";
                noteTextResource = "has_everything_worked_out_note";

            // technician time frame has passed
            }else{
                headerTextResource = "is_it_done_title";
                bodyTextResource = "is_it_done_body_mytechie";
                noteTextResource = "technician_late";
                noteTimeProp = timeSlotEnd+1;
            }

            // #267 MyTechie YouTube Embedding
            youtubeResource = this.getYouTubeMyTechie();

        }

        // if stage has been opened after submitting callback request, change content in small infoBox (mobile/browser)
        // -> see fnx #187 / CARE-748 / CARE-824 Bestätigungsseite nach Callbackwunsch
        // console.log("FNX: this.state.callback_submitted"); console.log( this.state.callback_submitted );
        // console.log("FNX: this.props.callbackSubmitted"); console.log( this.props.callbackSubmitted );

        if( this.state.callback_submitted ) {
            noteTextResource = "callback_confirm_note";
            infoBox = this.getInfoBox(noteTextResource, noteTimeProp);
            this.state.callback_submitted = false;
        }
        if( this.props.callbackSubmitted ) {
            noteTextResource = "callback_confirm_note";
            infoBox = this.getInfoBox(noteTextResource, noteTimeProp);
            // this.setState({callbackSubmitted: false});
        }

        return <Container>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <StatusBar
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                    customerWillGetAPackage={hardwareWasShipped(this.props.orderStatus)}
                />
                <SpacerRow/>
                <Header
                    textResource={headerTextResource}
                />
                <SpacerRow/>
                {youtubeResource}
                <TextBody
                    textResource={bodyTextResource}
                />

                <div className={"margin-top-10"}>
                    {infoBox}
                    <StackedBottomButtonPair
                        upperButtonTextResource={upperButtonTextResource}
                        upperButtonOnClick={this.props.nextStage}
                        lowerButtonTextResource={"there_was_a_problem"}
                        lowerButtonOnClick={this.props.contactVodafoneCallback}
                    />
                </div>
            </MobileView>

            <BrowserView>
                <Row>
                {footerLnk}
                </Row>
                <StatusBarDesktop
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                    customerWillGetAPackage={hardwareWasShipped(this.props.orderStatus)}
                />
                <Row>
                    <Col xs={7}  lg={{ size: 5, offset: 1 }} style={{marginTop:"12px"}}>
                        <Header
                            textResource={headerTextResource}
                        />
                        <SpacerRow/>
                        {youtubeResource}
                        <TextBody
                            textResource={bodyTextResource}
                        />
                        <SpacerRow/>
                        <Subtitle
                            textResource={"router_setup_time"}
                        />
                    </Col>
                    <Col xs={5}  lg={{ size: 4, offset: 1 }} className={"round-corners shadow bg-white"}>
                        <SpacerRow/>
                        <Header
                            showDesktopVersionSub={true}
                            textResource={"Router-Installation"}
                        />
                        <SpacerRow/>
                        {infoBox}
                        <SpacerRow/>
                        <StackedBottomButtonPair
                            upperButtonTextResource={"set_up_router"}
                            upperButtonOnClick={this.props.nextStage}
                            lowerButtonTextResource={"there_was_a_problem"}
                            lowerButtonOnClick={this.props.contactVodafoneCallback}
                            showDesktopVersion={true}
                        />
                    </Col>
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage8AppointmentDayPage);

